import RouteType from "@Route/types/Route.type";
import roundToTwoDecimals from "@Number/roundToTwoDecimals";

export default function getMinMaxPriceForType(routes: RouteType[]) {
    let min: number
    let max: number
    let cheapestCompanyId: string
    let priciestCompanyId: string

    routes.map((route: RouteType) => {
        if (!min || (!!route.prices.priceWithDiscount && route.prices.priceWithDiscount["1"]["1"] < min)) {
            min = route.prices.priceWithDiscount["1"]["1"]
            cheapestCompanyId = route.companyId
        }

        if (!max || (!!route.prices.priceWithDiscount && route.prices.priceWithDiscount["1"]["1"] > max)) {
            max = route.prices.priceWithDiscount["1"]["1"]
            priciestCompanyId = route.companyId
        }
    })

    return {
        min: `${roundToTwoDecimals(min)} EUR`,
        max: `${roundToTwoDecimals(max)} EUR`,
        cheapestCompanyId,
        priciestCompanyId,
    }
}